import React from "react";
import * as reactFlags from "react-flags-select";

const CountryFlag = ({selectedCountry, setInternationalizationModal}) => {
    const flagsFormat = selectedCountry?.isoCode[0] + selectedCountry?.isoCode[1].toLowerCase();
    const ReactFlags = reactFlags[flagsFormat];

    if (!ReactFlags) {
        return null
    } else {
        return (
            <ReactFlags onClick={() => setInternationalizationModal(true)}/>
        )
    }
};

export default CountryFlag;